import { getChangedLeadFieldsForGa } from '../../../../../refine-price/utils/submit-refine-price-analytics';
import { HealthFormValues } from '../../../../types';
import { INCOME_TIER_NONE } from '../../../../../../components/pricing-drawer/constants';
import constants from '../../../../../../ahm-constants';
import GA4Analytics from '../../../../../../analytics/ga4-analytics';
import getAgrAgeBracketFromAge from '../../../../../../utils/get-agr-age-bracket-from-age';
import getHasPartner from '../../../../utils/get-has-partner';

const getIncomeTierDimensionValue = (incomeTier: string) => (incomeTier === INCOME_TIER_NONE ? '4' : incomeTier);

const submitEmbeddedQuoteAnalytics = (values: HealthFormValues) => {
  const { phone, email, scale, age, partnerAge, incomeTier, incomeType, productType, state } = values;

  const memberAges = getHasPartner(scale) ? [age, partnerAge ?? 0] : [age];

  const changedFields = getChangedLeadFieldsForGa({ email, phone });

  GA4Analytics.submit({
    data: {
      /* eslint-disable camelcase */
      age_bracket: getAgrAgeBracketFromAge(Math.max(...memberAges)),
      changed_fields: changedFields,
      income_tier: getIncomeTierDimensionValue(incomeTier),
      income_type: incomeType,
      product_type: productType,
      scale,
      state,
      /* eslint-enable camelcase */
    },
    name: constants.ANALYTICS.EVENTS.ECOMMERCE_GA4.QUOTE_EMBEDDED,
  });
};

export default submitEmbeddedQuoteAnalytics;
